"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardedRoute = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var GuardedContainer_1 = require("./GuardedContainer");
/**
 * A route that will redirect to a given URL if the route matches but the authentication
 * context does not have the appropriate permissions.
 *
 * Note that UI guarding must be accompanied with API guarding. UI guarding is subject
 * to manipulation through changing the state or the code with development tools.
 */
var GuardedRoute = function (props) {
    var children = props.children, Component = props.component, render = props.render, rest = __rest(props, ["children", "component", "render"]);
    return (react_1.default.createElement(react_router_dom_1.Route, __assign({}, rest, { render: function (renderProps) {
            return (react_1.default.createElement(GuardedContainer_1.GuardedContainer, { requiredPermissions: props.requiredPermissions, notAllowedRender: function () { return react_1.default.createElement(react_router_dom_1.Redirect, { to: props.notAllowedRedirectPath || '/' }); } }, Component ? (react_1.default.createElement(Component, __assign({}, renderProps))) : render ? (render(renderProps)) : typeof children === 'function' ? (children(renderProps)) : (children)));
        } })));
};
exports.GuardedRoute = GuardedRoute;
//# sourceMappingURL=GuardedRoute.js.map